export default __webpack_public_path__ + "static/media/center-header.9175834c.png";